import React from "react";
import { colors } from "../../../share/constants/enums";
import Button from "../../../components/common/button";
import { Link } from "react-router-dom";
import YupupScreen from "./../../../assets/icons/LogoScreen.svg";

const CheckEmail = () => {
  const email = localStorage.getItem("email");
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <div className="object-cover">
        <img
          className="block h-12 xl:h-15.3 xl:w-26.9"
          alt="yupup-screen-logo"
          src={YupupScreen}
        />
      </div>
      <div className="flex flex-col space-y-3 text-center lg:mt-3.9 xl:mt-3.9 xl:space-y-4">
        <p className="text-heading font-bold lg:text-xl xl:text-xl 2xl:text-xl">
          Check Email
        </p>
        <p className="text-base lg:text-lg xl:text-lg font-normal">
          We Send A Reset Link To Your Email Address
        </p>
        <p className="text-base lg:text-lg xl:text-lg font-bold">{email}</p>
        <Link to="/new-password" className="no-underline">
          <Button
            className="w-31 md:w-40 lg:w-40 xl:w-40"
            title="Open Email"
            color={colors.primaryBlue}
            htmlType="submit"
          />
        </Link>
        <Link to="/login" className="no-underline">
          <span className="text-grey ">Back to Login</span>
        </Link>
      </div>
    </div>
  );
};

export default CheckEmail;
